import { render, staticRenderFns } from "./topicPush.vue?vue&type=template&id=42f252aa&scoped=true&"
import script from "./topicPush.vue?vue&type=script&lang=js&"
export * from "./topicPush.vue?vue&type=script&lang=js&"
import style0 from "./topicPush.vue?vue&type=style&index=0&id=42f252aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f252aa",
  null
  
)

component.options.__file = "topicPush.vue"
export default component.exports